import { ComponentProps } from "react";

import PageHeader from "@ds-developer/page-header";

export const pageHeaderPropsMap: Record<
  string,
  ComponentProps<typeof PageHeader>
> = {
  transactions: {
    title: "Transactions",
    breadcrumbs: [
      {
        title: "Home",
        link: "/",
      },
      {
        title: "Accounts",
      },
      {
        title: "Transactions",
      },
    ],
  },
  invoices: {
    title: "Invoices",
    breadcrumbs: [
      {
        title: "Home",
        link: "/",
      },
      {
        title: "Accounts",
        link: "/accounts",
      },
      {
        title: "Invoices",
      },
    ],
  },
};
